import { useQuery } from '@tanstack/react-query';
import { cycleService } from '../../services/cycleService';
import type { Cycle } from '../../models/cycle.types';

/**
 * Hook for cycles query (standard, non-realtime)
 * Fetches cycles with optional filtering for active only
 *
 * @param activeOnly - If true, only fetch active cycles
 * @returns Cycles data, loading state, and error
 */
export function useCyclesQuery(activeOnly?: boolean) {
  const queryResult = useQuery({
    queryKey: ['cycles', activeOnly],
    queryFn: async () => {
      if (activeOnly) {
        return await cycleService.getActive();
      }
      return await cycleService.getAll();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnMount: true,
  });

  return {
    cycles: queryResult.data || [],
    isLoading: queryResult.isLoading,
    error: queryResult.error,
  };
}
